function pad(value: number) {
  return String(value).padStart(2, "0");
}

function buildValidDate(year: number, month: number, day: number) {
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    Number.isNaN(date.getTime()) ||
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return null;
  }

  return date;
}

export function formatBirthDateInput(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 8);

  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function parseBirthDate(value: string) {
  const normalizedValue = value.trim();
  let day: number;
  let month: number;
  let year: number;

  const brMatch = normalizedValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  const isoMatch = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (brMatch) {
    day = Number(brMatch[1]);
    month = Number(brMatch[2]);
    year = Number(brMatch[3]);
  } else if (isoMatch) {
    year = Number(isoMatch[1]);
    month = Number(isoMatch[2]);
    day = Number(isoMatch[3]);
  } else {
    return null;
  }

  const date = buildValidDate(year, month, day);

  if (!date) {
    return null;
  }

  return {
    day,
    month,
    year,
    date,
    iso: `${year}-${pad(month)}-${pad(day)}`,
    display: `${pad(day)}/${pad(month)}/${year}`,
  };
}

export function formatBirthDateForDisplay(value: string) {
  const parsed = parseBirthDate(value);
  return parsed?.display ?? value;
}

export function isAtLeastMinimumAge(value: string, minimumAge: number) {
  const parsed = parseBirthDate(value);

  if (!parsed) {
    return false;
  }

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const currentDay = today.getDate();

  let age = currentYear - parsed.year;

  if (
    currentMonth < parsed.month ||
    (currentMonth === parsed.month && currentDay < parsed.day)
  ) {
    age -= 1;
  }

  return age >= minimumAge;
}
